export const TASK_TEMPLATES = [

{
id:"anime-product",
category:"电商卖货",
title:"动漫手办销售方案",

description:"生成动漫产品营销方案",

form:{
role:"你是一名资深电商运营专家",

goal:"帮助提升动漫手办销量",

context:"目标用户为动漫爱好者",

task:"制定商品推广方案",

constraint:"避免夸大宣传",

outputFormat:"输出完整营销方案"
}

}

]